import { IComponentOptions } from "angular";
import { AssigneeActions, IAssigneeIdMap, IAssigneesStoreState } from "@gtmhub/assignees";
import { IExtendedRootScopeService } from "@gtmhub/shared/ng-extensions";
import { IUIError } from "@gtmhub/error-handling";
import { INgRedux } from "@gtmhub/state-management";
import { GtmhubController } from "@gtmhub/core";

interface IAssigneeRedux {
  assigneesIdMap: IAssigneeIdMap;
  assigneesFetched: boolean;
  assigneesError: IUIError;
}

const bindStateToCtrl = (state: IAssigneesStoreState): IAssigneeRedux => {
  const { map: assigneesIdMap, isFetched: assigneesFetched, error: assigneesError } = state.assignees;

  return {
    assigneesIdMap,
    assigneesFetched,
    assigneesError,
  };
};

/**
 * @example <assignee id="{{person.id}}"  avatar-size="s-20" name-classes=""></assignee>
 * @param id string
 * @param avatarSize "s-16" | "s-17" | "s-20" | "s-24" | "s-26" | "s-40"| "s-32" | "s-70" // default is s-20
 * @param nameClasses string
 */

export type AvatarSize = "s-16" | "s-17" | "s-20" | "s-24" | "s-26" | "s-40" | "s-30" | "s-32" | "s-70";
export interface IAssigneeBindings {
  id: string;
  avatarSize: AvatarSize;
  nameClasses: string;
}
export interface AssigneeCtrl extends IAssigneeBindings, IAssigneeRedux {}
export class AssigneeCtrl extends GtmhubController {
  static $inject = ["$ngRedux", "AssigneeActions", "$scope"];
  constructor($ngRedux: INgRedux, assigneeActions: AssigneeActions, private $scope: IExtendedRootScopeService) {
    super();

    this.onDestroy($ngRedux.connect(bindStateToCtrl)(this));
    $ngRedux.dispatch(assigneeActions.getAssignees());
  }

  $onInit(): void {
    if (!this.nameClasses) {
      this.nameClasses = "";
    }

    if (!this.avatarSize) {
      this.avatarSize = "s-20";
    }

    this.$scope
      .watchUntilAndRejectOnError(
        () => this.assigneesFetched,
        () => this.assigneesError
      )
      .catch(console.error);
  }
}

export const AssigneeComponent: IComponentOptions = {
  template: `
  <circle-avatar assignee="$ctrl.assigneesIdMap[$ctrl.id]" size="{{ ::$ctrl.avatarSize }}" showTooltip="false"></circle-avatar>
  <div class="align-self-c" ng-class="$ctrl.nameClasses"><full-name entity="$ctrl.assigneesIdMap[$ctrl.id]"></full-name></div>`,
  controller: AssigneeCtrl,
  bindings: {
    id: "@",
    avatarSize: "@",
    nameClasses: "@",
  },
};
